import { render, staticRenderFns } from "./FamousPediaEditWeb.vue?vue&type=template&id=791d317a&"
import script from "./FamousPediaEditWeb.vue?vue&type=script&lang=js&"
export * from "./FamousPediaEditWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports